<template>
  <v-card
    elevation="0"
    class="challenge-header-card"
    style="width: 100%; height: 100%;"
  >
    <v-row
      align="center"
    >
      <v-text-field
        v-model="phrase"
        label="Challenge Phrase"
        color="orange"
        hint="e.g. 'How might the team', 'How might we'"
        persistent-hint
        :disabled="disabled"
      />
    </v-row>
    <v-row>
      <v-col style="flex-basis: 30%;">
        <ColorList
          title="Box Colors"
          buttonText="Add Box Color"
          colorsField="nodeColors"
          defaultColorField="defaultNodeColor"
          :disabled="disabled"
        />
      </v-col>
      <v-col style="flex-basis: 30%;">
        <ColorList
          title="Font Colors"
          buttonText="Add Font Color"
          colorsField="fontColors"
          defaultColorField="defaultFontColor"
          :disabled="disabled"
        />
      </v-col>
      <v-col style="flex-basis: 30%;">
        <ColorList
          title="Arrow Colors"
          buttonText="Add Arrow Color"
          colorsField="linkColors"
          defaultColorField="defaultLinkColor"
          :disabled="disabled"
        />
      </v-col>
      <v-col style="flex-basis: 30%;">
        <ColorList
          title="Dot Colors"
          buttonText="Add Dot Color"
          colorsField="dotColors"
          defaultColorField="defaultDotColor"
          :disabled="disabled"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import ColorList from './ColorList'

export default {
  name: 'ChallengeHeader',

  props: ['disabled'],

  components: {
    ColorList
  },

  data () {
    return {
      newCode: null
    }
  },

  computed: {
    ...mapState({
      currentlyViewedChallenge: state => state.challenge.currentlyViewedChallenge
    }),
    ...mapState(['auth']),

    isActive () {
      return this.currentlyViewedChallenge.uuid === this.auth.userInfo.activeChallenge
    },

    phrase: {
      get () {
        return this.currentlyViewedChallenge.phrase
      },

      set (text) {
        const updatedChallenge = this.currentlyViewedChallenge
        updatedChallenge.phrase = text

        this.setCurrentlyViewedChallenge(updatedChallenge)
      }
    }
  },

  methods: {
    ...mapMutations(['setCurrentlyViewedChallenge'])
  }
}
</script>

<style lang="sass" scoped>
  .challenge-header-card
    width: 100%
    height: 23rem
    padding: 2em
    position: relative
    margin-bottom: -3em

  .challenge-header-text
    font-size: 4em
</style>
